import { useGetAmendmentsQuery } from '@xemplo/amendment-query';
import { useServerSideState } from '@xemplo/table';

import { summaryColumns } from './payrun-amendments-summary-list.helper';
import * as S from './payrun-amendments-summary-list.style';

export type PayrunAmendmentsSummaryListProps = {
  payrunId: string;
};

/**
 * Read-only, paginated list of the amendments attached to a payrun. Shows only
 * base details (worker, type, total amount) with no sorting or row interaction.
 */
export function PayrunAmendmentsSummaryList({
  payrunId,
}: Readonly<PayrunAmendmentsSummaryListProps>) {
  const { pagination, onPaginationChange } = useServerSideState({
    pageIndex: 0,
    pageSize: 10,
  });
  const { pageIndex, pageSize } = pagination;

  const { data, isLoading } = useGetAmendmentsQuery({
    requestParams: {
      page: pageIndex + 1,
      per_page: pageSize,
      filter: { payrunId },
    },
  });

  return (
    <S.Table
      data={data?.result.rows ?? []}
      columns={summaryColumns}
      isListTable
      enablePagination
      manualPagination
      enableSorting={false}
      enableRowSelection={false}
      pageCount={data?.result.total_Pages ?? 0}
      state={{ pagination }}
      onPaginationChange={onPaginationChange}
      totalRowCount={data?.result.total ?? 0}
      isLoading={isLoading}
    />
  );
}
